export default "__VITE_PUBLIC_ASSET__2dfcf15d__"